import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { TileVariant } from './types/TileVariant';
import { useTileVariantColors } from './hooks/useTileVariantColors';

interface ITileProps {
	variant: TileVariant;
	children: ReactNode;
}

export const Tile = ({ variant, children }: ITileProps) => {
	const colors = useTileVariantColors(variant);

	return (
		<StyledTile aria-hidden="true" {...colors}>
			{children}
		</StyledTile>
	);
};

interface IStyledTileProps {
	backgroundColor: string;
	foregroundColor?: string;
}

export const StyledTile = styled.div<IStyledTileProps>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-width: 130px;
	min-height: 80px;
	background-color: ${({ backgroundColor }) => backgroundColor};
	${({ foregroundColor }) =>
		foregroundColor ? `color: ${foregroundColor};` : ''};
	font-size: 20px;
	line-height: 1;
	font-weight: 700;
`;
